import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthService } from './auth.service';
import { RestorePasswordComponent } from '../auth/restore-password/restore-password.component';

/**
 * Forces the restore-password dialog while {@link AuthService.promptNewPassword} is true.
 * Safe to call from AuthGuard on every navigation — opens at most one dialog.
 */
@Injectable({ providedIn: 'root' })
export class ForcePasswordChangeService {
  private dialogRef: DynamicDialogRef | null = null;

  constructor(
    private dialogService: DialogService,
    private authService: AuthService
  ) {}

  /** Opens the restore-password dialog when the session still requires a password change. */
  ensureOpen(): void {
    if (!this.authService.promptNewPassword || this.dialogRef) {
      return;
    }

    this.dialogRef = this.dialogService.open(RestorePasswordComponent, {
      header: 'Restore Password',
      modal: true,
      width: '450px',
      styleClass: 'max-w-[95vw]',
      closable: false,
      closeOnEscape: false,
      dismissableMask: false,
    });

    this.dialogRef.onClose.subscribe(() => {
      this.dialogRef = null;
      // If the flag is still set (e.g. closed without success), reopen.
      if (this.authService.promptNewPassword) {
        queueMicrotask(() => this.ensureOpen());
      }
    });
  }
}
